import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from './environments/environment';
import { initFrameBuster } from './app/shared/common/frame-buster';

initFrameBuster();

const rumConfig = environment.datadogRum;

const isPlaceholder = (value: string) =>
  !value || value.startsWith('<') || value.endsWith('>');

const canInitializeRum =
  !!rumConfig?.applicationId &&
  !!rumConfig?.clientToken &&
  !!rumConfig?.site &&
  !isPlaceholder(rumConfig.service) &&
  !isPlaceholder(rumConfig.env) &&
  !isPlaceholder(rumConfig.version);

if (canInitializeRum) {
  datadogRum.init({
    applicationId: rumConfig.applicationId,
    clientToken: rumConfig.clientToken,
    site: rumConfig.site,
    service: rumConfig.service,
    env: rumConfig.env,
    version: rumConfig.version,
    sessionSampleRate: rumConfig.sessionSampleRate,
    sessionReplaySampleRate: rumConfig.sessionReplaySampleRate,
    trackResources: rumConfig.trackResources,
    trackUserInteractions: rumConfig.trackUserInteractions,
    trackLongTasks: rumConfig.trackLongTasks,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));